import { Row, Col } from "reactstrap";
import "./Footer.css";
import Container from "react-bootstrap/Container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "./media/logo 1.png";

const Footer = () => {
  return (
    <Container fluid className="p-0 m-0">
      <Row
        style={{
          marginLeft: "5%",
          marginRight: "5%",
          padding: "2%",
          borderTop: "2px solid #f4511e",
        }}
      >
        <Col
          sm={12}
          lg={6}
          className="d-flex justify-content-center text-center my-auto"
        >
          <div className="logo">
            <img alt="" src={logo} className="d-inline-block align-top" />
          </div>
        </Col>
        <Col sm={12} lg={6}>
          <Row className="footer-contact-details">
            <Col sm={12} className="text">
              <FontAwesomeIcon className="footer-contact" icon="location-pin" />{" "}
              Faulconer Drive, Suite 4 • Charlottesville, CA, 12345
            </Col>
          </Row>
          <Row className="footer-contact-details">
            <Col sm={12} lg={6} className="text">
              <FontAwesomeIcon className="footer-contact" icon="phone" /> (123)
              456-7890
            </Col>
            <Col sm={12} lg={6} className="text">
              <FontAwesomeIcon className="footer-contact" icon="fax" /> (123)
              456-7890
            </Col>
          </Row>
          <Row>
            <div className="footer-social">
              <span className="copyright">Social media</span>
              <a href="">
                <FontAwesomeIcon icon={["fab", "facebook"]} />
              </a>
              <a href="">
                <FontAwesomeIcon icon={["fab", "twitter"]} />
              </a>
              <a href="">
                <FontAwesomeIcon icon={["fab", "linkedin"]} />
              </a>
              <a href="">
                <FontAwesomeIcon icon={["fab", "youtube"]} />
              </a>
              <a href="">
                <FontAwesomeIcon icon={["fab", "instagram"]} />
              </a>
              <a href="">
                <FontAwesomeIcon icon={["fab", "google-plus"]} />
              </a>
              <a href="">
                <FontAwesomeIcon icon={["fab", "pinterest"]} />
              </a>
              {/* <a href="">
                <FontAwesomeIcon icon={["fab", "apple"]} />
              </a> */}
            </div>
          </Row>
        </Col>
      </Row>
      <Row style={{ marginLeft: 0, marginRight: 0, padding: "2%" }}>
        <Col sm={12} lg={6} style={{ textAlign: "center" }}>
          <div className="footer-links">
            <p className="footer-list">
              <a className="link-1" href="#">
                ABOUT US
              </a>
              <a href="#">CONTACT US</a>
              <a href="#">HELP</a>
              <a href="#">PRIVACY POLICY</a>
              <a href="#">DISCLAIMER</a>
            </p>
          </div>
        </Col>
        <Col
          sm={12}
          lg={6}
          style={{ textAlign: "center" }}
          className="copyright"
        >
          Copyright &copy; 2020 Minimumlivingcost. All rights reserved
        </Col>
      </Row>
    </Container>
  );
};

export default Footer;
